/*!
 * Druckelite24 Warenkorb-Wächter
 * 1) Veredelungs-Aufpreise (Konfigurator / Vereinsaufdruck) passend zu den Textilien halten (_dl24_gruppe / _dl24_ver).
 *    Fehlende Veredelungs-Positionen einer Gruppe werden automatisch ergänzt (z. B. Vereinsaufdruck bei JAKO im Vereinsshop).
 * 3) Angebots-PDF: Veredelung je Teil in die Produktposition einrechnen, Logo-Links ausblenden, Mockups (vorne/hinten) erzeugen.
 * 2) Logo-Aufbereitung (2,99 € einmalig): Hat der Kunde sie angehakt (sessionStorage dl24_svc_on),
 *    liegt sie genau 1× im Warenkorb, sobald Ware drin ist – egal wie die Ware hineinkam (LPO, Größenlauf,
 *    normaler Button, Konfigurator). Entfernt der Kunde sie im Warenkorb, bleibt sie draußen.
 *    Nach einer Bestellung (neuer Warenkorb) wird sie nicht automatisch wieder hinzugefügt.
 */
(function () {
  'use strict';
  if (window.DL24Guard) return;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var ofetch = window.fetch.bind(window);
  var busy = null, again = false, lastUpload = 0;
  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (e) {} return null; }
  function json(url, body) {
    return ofetch(root + url, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  // 19.10.2026: Mengenrabatt auch auf den Druck. Shopify rabattiert nur die Textilien (Rabattstufe 5–30 %); der Wächter setzt
  // dazu die passende Druck-Variante aus „Veredelung Druck“ (Mengenrabatt) – Stufe = Rabatt, den Shopify auf das Textil gibt.
  var TIER = {"58594346664280":{"5":58846916936024,"10":58846916968792,"15":58846917001560,"20":58846917034328,"25":58846917067096,"30":58846917099864},"58594346697048":{"5":58846917132632,"10":58846917165400,"15":58846917198168,"20":58846917230936,"25":58846917263704,"30":58846917296472},"58594346729816":{"5":58846917329240,"10":58846917362008,"15":58846917394776,"20":58846917427544,"25":58846917460312,"30":58846917493080},"58819644653912":{"5":58846917525848,"10":58846917558616,"15":58846917591384,"20":58846917624152,"25":58846917656920,"30":58846917689688}};
  function rateOf(it) {
    var r = 0;
    (it.line_level_discount_allocations || []).forEach(function (a) { var t = a.discount_application && a.discount_application.title || ''; var m = String(t).match(/(\d+)\s*%\s*Mengenrabatt/i); if (m && Number(a.amount) > 0) r = Math.max(r, Number(m[1])); });
    (it.discounts || []).forEach(function (a) { var m = String(a.title || '').match(/(\d+)\s*%\s*Mengenrabatt/i); if (m && Number(a.amount) > 0) r = Math.max(r, Number(m[1])); });
    return r;
  }
  // 19.10.2026 (Chef): Druckzeilen je Position benennen („Druck: Brustlogo“, „Druck: Rücken groß“ …) statt nur Klein/Groß –
  // für Shopify-Admin, Bestellmail und Produktionszentrale. Nur Basics-Konfigurator; Vereinsdrucke bleiben wie bisher.
  var BASIC_VAR = { klein: '58594346664280', gross: '58594346697048', xl: '58594346729816', text: '58819644653912' };
  var BASIC_POS = [['Brustlogo', 'Brustlogo', 'klein'], ['Logo vorne groß', 'Vorne groß', 'gross'], ['Rückenlogo', 'Rücken groß', 'gross'], ['Name/Initialen', 'Name/Initialen', 'text']];
  function basicPositions(p) {
    var out = [];
    if (p._dl24_kind === 'basic') {
      BASIC_POS.forEach(function (b) {
        if (!/^https?:/.test(String(p[b[0]] || ''))) return;
        var xl = p[b[0] + ' – Größe'] === 'Übergröße';
        out.push({ v: BASIC_VAR[xl ? 'xl' : b[2]], label: xl ? b[1].replace(' groß', '') + ' Übergröße' : b[1] });
      });
    } else {
      // Vereinsshops: Positionen aus den Feldnamen (z. B. „Vereinslogo Brust“, „Rückendruck …“, „Initialen / Nummer …“).
      Object.keys(p).forEach(function (k) {
        if (k[0] === '_') return;
        var v = String(p[k] || '').trim(); if (!v) return;
        var name = k.split(' · ')[0].trim();
        if (/^https?:/.test(v)) out.push({ v: BASIC_VAR[/rück|rueck|vorne gro/i.test(k) ? 'gross' : 'klein'], label: name });
        else if (/initialen|nummer|name/i.test(k) && !/besonderheit|werbung|hinweis/i.test(k)) out.push({ v: BASIC_VAR.text, label: 'Initialen/Name „' + v + '“' });
      });
    }
    // Nur übernehmen, wenn es exakt zur berechneten Druckliste passt – sonst wie bisher zusammengefasst.
    var spec = {}, mine = {};
    String(p._dl24_ver || '').split(',').forEach(function (part) { var m = part.match(/^(\d+)x(\d+)$/); if (m) spec[m[1]] = (spec[m[1]] || 0) + Number(m[2]); });
    out.forEach(function (o) { mine[o.v] = (mine[o.v] || 0) + 1; });
    var ok = out.length && Object.keys(spec).length === Object.keys(mine).length && Object.keys(spec).every(function (k) { return spec[k] === mine[k]; });
    return ok ? out : null;
  }
  function refresh() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    if (/\/cart\/?$/.test(location.pathname)) location.reload();
  }

  function run() {
    return json('cart.js').then(function (cart) {
      learn(cart);
      var groups = {}, svc = [], goods = 0, updates = {}, change = false, uploadWait = false;
      (cart.items || []).forEach(function (it) {
        var p = it.properties || {}, g = p._dl24_gruppe;
        // kurzzeitige Upload-Position des Druck-Konfigurators. 19.10.2026: Bleibt sie liegen (Seite während des Uploads verlassen),
        // würde der Kunde 4,99 € zu viel zahlen – liegengebliebene Upload-Positionen werden entfernt, laufende nicht angetastet.
        if (p._dl24_upload) { if (Date.now() - lastUpload > 20000) { updates[it.key] = 0; change = true; } else uploadWait = true; return; }
        if (p._dl24_service) { svc.push(it); return; }
        if (!g || p._dl24_ver != null) goods++;
        if (!g) return;
        var grp = groups[g] = groups[g] || { goods: [], ver: [] };
        if (p._dl24_ver != null) grp.goods.push(it); else grp.ver.push(it);
      });
      // 18.10.2026: Veredelung je Textilposition als „verschachtelte Position“ (parent_line_key) – Checkout zeigt sie unter dem Textil statt als eigene Artikel.
      if (uploadWait) setTimeout(check, 21000);
      var adds = [], svcAdd = false, legacy = {};
      Object.keys(groups).forEach(function (g) {
        var grp = groups[g], need = {}, seen = {};
        grp.goods.forEach(function (it) {
          var rate = rateOf(it), pos = basicPositions(it.properties);
          if (pos) {
            pos.forEach(function (o) { var vid = (TIER[o.v] && TIER[o.v][String(rate)]) || o.v, k = it.key + '|' + vid + '|' + o.label; need[k] = (need[k] || 0) + it.quantity; });
            return;
          }
          String(it.properties._dl24_ver || '').split(',').forEach(function (part) {
            var m = part.match(/^(\d+)x(\d+)$/); if (!m) return;
            var vid = (TIER[m[1]] && TIER[m[1]][String(rate)]) || m[1];
            need[it.key + '|' + vid + '|'] = (need[it.key + '|' + vid + '|'] || 0) + it.quantity * Number(m[2]);
          });
        });
        grp.ver.forEach(function (it) {
          var par = it.parent_relationship && it.parent_relationship.parent_key, k = par + '|' + it.variant_id + '|' + ((it.properties || {}).Druck || ''), want = (par && !seen[k]) ? (need[k] || 0) : 0;
          seen[k] = true; if (!par) legacy[it.key] = 1;
          if (it.quantity !== want) { updates[it.key] = want; change = true; }
        });
        Object.keys(need).forEach(function (k) {
          if (seen[k] || !(need[k] > 0)) return;
          var t = k.split('|'), props = { _dl24_gruppe: g };
          if (t[2]) props.Druck = t[2];
          adds.push({ id: Number(t[1]), quantity: need[k], parent_line_key: t[0], properties: props });
        });
      });

      // Logo-Aufbereitung
      var on = ss('dl24_svc_on'), token = String(cart.token || ''), known = ss('dl24_svc_cart');
      if (svc.length) {
        if (on === '0') svc.forEach(function (it) { updates[it.key] = 0; change = true; });
        else {
          if (on === '1') ss('dl24_svc_cart', token);
          svc.forEach(function (it, i) { var want = goods && i === 0 ? 1 : 0; if (it.quantity !== want) { updates[it.key] = want; change = true; } });
        }
      } else if (on === '1' && goods) {
        if (known) { ss('dl24_svc_on', '0'); ss('dl24_svc_cart', null); } // im Warenkorb entfernt oder neuer Warenkorb nach Bestellung
        else if (ss('dl24_svc_variant')) { svcAdd = true; adds.push({ id: Number(ss('dl24_svc_variant')), quantity: 1, properties: { 'Für': ss('dl24_svc_for') || 'Bestellung', 'Umfang': 'einmalig – alle Logos inklusive', _dl24_service: 'logo-aufbereitung' } }); }
      }

      // Erst neue (verschachtelte) Positionen anlegen, dann alte entfernen – klappt das Anlegen nicht, bleiben die alten Aufpreise stehen.
      var added = false;
      var p = adds.length ? json('cart/add.js', { items: adds }).then(function () { added = true; }, function () {
        Object.keys(legacy).forEach(function (k) { delete updates[k]; });
        if (svcAdd) document.dispatchEvent(new CustomEvent('dl24:svc-failed'));
      }) : Promise.resolve();
      return p.then(function () {
        return Object.keys(updates).length ? json('cart/update.js', { updates: updates }).then(function () { return true; }, function () { return added; }) : added;
      }).then(function (changed) {
        if (!(added && svcAdd)) return changed;
        return json('cart.js').then(function (c) { ss('dl24_svc_cart', String(c.token || '')); document.dispatchEvent(new CustomEvent('dl24:svc-added')); return true; }, function () { return true; });
      }).then(function (changed) { if (changed) refresh(); });
    }).catch(function () {});
  }

  /* ---------- Stückzahl-Anzeige ohne Veredelungs-/Service-Positionen ---------- */
  var extraQty = 0;
  function nonPieces(cart) {
    var n = 0;
    (cart && cart.items || []).forEach(function (it) {
      var p = it.properties || {};
      if (p._dl24_service || p._dl24_upload || (p._dl24_gruppe && p._dl24_ver == null)) n += it.quantity;
    });
    return n;
  }
  function pagePieces(total) {
    document.querySelectorAll('.de24-cart-count').forEach(function (el) { el.textContent = total; });
    document.querySelectorAll('.de24-cart-list-heading span').forEach(function (el) { el.textContent = el.textContent.replace(/\d+/, total); });
  }
  function learn(cart) {
    if (!cart || !Array.isArray(cart.items)) return;
    extraQty = nonPieces(cart);
    var total = Math.max(0, (cart.item_count || 0) - extraQty);
    document.querySelectorAll('cart-count').forEach(function (el) { if (el.__dl24Set) el.__dl24Set(total); });
    pagePieces(total);
  }
  (function patchCount() {
    var C = window.customElements && customElements.get('cart-count');
    if (!C) { if (document.readyState !== 'complete') return setTimeout(patchCount, 50); return; }
    var d = Object.getOwnPropertyDescriptor(C.prototype, 'itemCount');
    if (!d || !d.set || C.prototype.__dl24) return;
    C.prototype.__dl24 = 1;
    Object.defineProperty(C.prototype, 'itemCount', { configurable: true, enumerable: d.enumerable,
      get: function () { return d.get ? d.get.call(this) : undefined; },
      set: function (n) {
        var self = this;
        self.__dl24Set = function (v) { d.set.call(self, v); };
        d.set.call(this, Math.max(0, Number(n) - extraQty));
        clearTimeout(window.__dl24CountT);
        window.__dl24CountT = setTimeout(function () { json('cart.js').then(learn, function () {}); }, 150);
      } });
    document.querySelectorAll('cart-count').forEach(function (el) { el.__dl24Set = function (v) { d.set.call(el, v); }; });
  })();
  window.addEventListener('cart:change', function (e) { var c = e.detail && e.detail.cart; if (c && Array.isArray(c.items)) extraQty = nonPieces(c); }, true);

  function check() {
    if (busy) { again = true; return busy; }
    busy = run().then(function () { busy = null; if (again) { again = false; return check(); } });
    return busy;
  }


  /* ---------- Angebots-PDF: Vereinsaufdruck in die Produktposition einrechnen + Mockups ---------- */
  var MOCK = window.__cpMock = window.__cpMock || {};
  (function () {
    var d = Object.getOwnPropertyDescriptor(HTMLImageElement.prototype, 'src');
    if (!d || HTMLImageElement.prototype.__cpSrc) return;
    HTMLImageElement.prototype.__cpSrc = 1;
    Object.defineProperty(HTMLImageElement.prototype, 'src', { configurable: true, enumerable: d.enumerable,
      get: function () { return d.get.call(this); },
      set: function (v) { d.set.call(this, MOCK[v] || v); } });
  })();
  function loadImg(url) { return new Promise(function (res) { if (!url) return res(null); var i = new Image(); i.crossOrigin = 'anonymous'; i.onload = function () { res(i); }; i.onerror = function () { res(null); }; i.src = url; }); }
  // 26.10.2026: Erkennung auf dem 600-px-Bild von Shopify (wie auf der Produktseite) – das herunterskalierte 1200-px-Bild ist zu weich,
  // das hellgraue JAKO-Logo (z. B. Iconic) wurde dann nicht gefunden und Werbung/Logo saßen falsch.
  function jako(img, iconic) {
    var g = { jx: 32.5, jy: 23, jw: 7.5, jh: 2.5 };
    try { var N = 600, c = document.createElement('canvas'); c.width = c.height = N; var x = c.getContext('2d'); x.drawImage(img, 0, 0, N, N); var d = x.getImageData(0, 0, N, N).data;
      var P = function (X, y) { var k = (y * N + X) * 4; return d[k] + d[k + 1] + d[k + 2]; }, x0 = N, y0 = N, x1 = 0, y1 = 0, n = 0, X, y;
      for (y = 60; y < 330; y++) for (X = 60; X < 300; X++) { if (P(X, y) > 680 && P(X - 14, y) < 150 && P(X + 14, y) < 150 && P(X, y - 12) < 150 && P(X, y + 12) < 150) { n++; if (X < x0) x0 = X; if (X > x1) x1 = X; if (y < y0) y0 = y; if (y > y1) y1 = y; } }
      var good = function () { return n > 20 && x1 - x0 > 15 && x1 - x0 < 90 && y1 - y0 < 40; };
      if (!good()) { // graue/gemusterte Flächen (Iconic)
        var pts = [];
        for (y = 60; y < 330; y++) for (X = 60; X < 300; X++) { var v = P(X, y); if (v > 660 && P(X - 14, y) < v - 280 && P(X + 14, y) < v - 280 && P(X, y - 12) < v - 280 && P(X, y + 12) < v - 280) pts.push([X, y]); }
        n = 0;
        if (pts.length > 20) {
          var md = function (a) { a = a.slice().sort(function (p, q) { return p - q; }); return a[a.length >> 1]; };
          var mx = md(pts.map(function (p) { return p[0]; })), my = md(pts.map(function (p) { return p[1]; }));
          var q = pts.filter(function (p) { return Math.abs(p[0] - mx) < 50 && Math.abs(p[1] - my) < 15; }); n = q.length;
          if (n) { x0 = Math.min.apply(null, q.map(function (p) { return p[0]; })); x1 = Math.max.apply(null, q.map(function (p) { return p[0]; })); y0 = Math.min.apply(null, q.map(function (p) { return p[1]; })); y1 = Math.max.apply(null, q.map(function (p) { return p[1]; })); }
        }
      }
      if (good()) {
        g = { jx: x0 / 6, jy: y0 / 6, jw: (x1 - x0) / 6, jh: (y1 - y0) / 6 };
        if (iconic) {
          var band = function (X) { X = Math.round(X); var b0 = -1; for (var yy = y1 + 4; yy < Math.min(N - 1, y1 + 170); yy++) { var w = P(X, yy) > 520; if (w && b0 < 0) b0 = yy; if (!w && b0 >= 0) return yy - b0 > 4 ? [b0, yy] : null; } return null; };
          var jw = x1 - x0, aw = jw * 1.45, ax = (x0 + x1) / 2 + jw * .3, L = band(ax - aw / 2), R = band(ax + aw / 2), tx = ax + jw * .1, T = band(tx);
          if (L && R) { var cl = (L[0] + L[1]) / 2, cr = (R[0] + R[1]) / 2; g.ic = { ax: ax / 6, ay: (cl + cr) / 12, aw: aw / 6, rot: Math.atan2(cr - cl, aw), tx: tx / 6, ty: ((T ? T[1] : Math.max(L[1], R[1])) + jw * .2) / 6, fs: jw * .42 / 6 };
            var mx = N - ax, mL = band(mx - aw / 2), mR = band(mx + aw / 2), mC = band(mx);
            if (mL && mR) { var ml = (mL[0] + mL[1]) / 2, mr = (mR[0] + mR[1]) / 2, bh = mC ? mC[1] - mC[0] : Math.min(mL[1] - mL[0], mR[1] - mR[0]); g.ic.mx = mx / 6; g.ic.my = (ml + mr) / 12; g.ic.mrot = Math.atan2(mr - ml, aw); g.ic.mfs = Math.min(jw * .5, bh * .72) / 6; } }
        }
      }
    } catch (e) {}
    return g;
  }
  var fontReady = null;
  function font(url) { if (!url || !window.FontFace) return Promise.resolve(); if (!fontReady) { var f = new FontFace('DE24 Vereinsschrift', 'url(' + url + ')'); fontReady = f.load().then(function (ff) { document.fonts.add(ff); }).catch(function () {}); } return fontReady; }
  function mock(it, side) {
    var p = it.properties || {}, keys = Object.keys(p), S = 1200;
    var frontKey = keys.filter(function (k) { return k[0] !== '_' && /^https?:/.test(String(p[k])) && !/rück|rueck/i.test(k); })[0];
    var backKey = keys.filter(function (k) { return k[0] !== '_' && /^https?:/.test(String(p[k])) && /rück|rueck/i.test(k) && !/groß rücken/i.test(k); })[0];
    // 26.10.2026: Vereinslogo groß hinten (unter dem Rückendruck) und Initialen nur als Outline unter der Werbung
    var bigKey = keys.filter(function (k) { return k[0] !== '_' && /^https?:/.test(String(p[k])) && /groß rücken/i.test(k); })[0];
    var txtOutline = keys.some(function (k) { return /initialen|nummer/i.test(k) && /outline/i.test(k) && k[0] !== '_'; });
    var txt = keys.filter(function (k) { return /initialen|nummer/i.test(k) && k[0] !== '_'; }).map(function (k) { return p[k]; })[0] || '';
    if (p._dl24_layout) return mockBasic(it, side);
    if (side === 'back' && !backKey && !bigKey) return Promise.resolve(null);
    return Promise.all([loadImg(it.img_front), loadImg(side === 'back' ? it.img_back : null), loadImg(frontKey && p[frontKey]), loadImg(backKey && p[backKey]), loadImg(it.ad_logo), font(it.font), loadImg(it.iconic ? it.ad_dark : null), loadImg(bigKey && p[bigKey]), loadImg(it.img_front && String(it.img_front).replace(/width=\d+/, 'width=600'))]).then(function (r) {
      var fr = r[0], bk = r[1], lg = r[2], bl = r[3], ad = r[4]; if (!fr || (side === 'back' && !bk)) return null;
      var g = jako(r[8] || fr, it.iconic), ic = it.iconic && g.ic, adD = r[6], c = document.createElement('canvas'); c.width = c.height = S; var x = c.getContext('2d'), pc = function (v) { return v / 100 * S; };
      if (side === 'front') {
        x.drawImage(fr, 0, 0, S, S); var jcx = g.jx + g.jw / 2;
        if (ic && adD) { x.save(); x.translate(pc(ic.ax), pc(ic.ay)); x.rotate(ic.rot); var dw = pc(ic.aw), dh = dw * adD.height / adD.width; x.drawImage(adD, -dw / 2, -dh / 2, dw, dh); x.restore(); }
        else if (ad) { var aw = g.jw * 1.08; x.drawImage(ad, pc(jcx - aw / 2), pc(g.jy + g.jh + Math.max(.9, g.jh * .45)), pc(aw), pc(aw) * ad.height / ad.width); }
        var lw = g.jw * 1.25, lcx = 100 - jcx - 3.2, lh = lg ? lw * lg.height / lg.width : lw * 1.43, lt = g.jy + g.jh / 2 - lh / 2;
        if (lg) x.drawImage(lg, pc(lcx - lw / 2), pc(lt), pc(lw), pc(lh));
        if (txt && ic && it.ic_band && ic.mx != null) { var mz = Math.round(pc(ic.mfs)); x.save(); x.translate(pc(ic.mx), pc(ic.my)); x.rotate(ic.mrot); x.textAlign = 'center'; x.textBaseline = 'middle'; x.font = mz + 'px "DE24 Vereinsschrift", Impact, sans-serif'; x.fillStyle = '#111'; x.fillText(String(txt).toUpperCase(), 0, 0); x.restore(); }
        else if (txt && ic) { var fz = Math.round(pc(ic.fs)); x.textAlign = 'center'; x.textBaseline = 'top'; x.font = '900 ' + fz + 'px Arial, Helvetica, sans-serif'; x.lineJoin = 'round'; x.lineWidth = fz * .1; x.strokeStyle = '#fff'; x.strokeText(String(txt).toUpperCase(), pc(ic.tx), pc(ic.ty)); x.fillStyle = '#111'; x.fillText(String(txt).toUpperCase(), pc(ic.tx), pc(ic.ty)); }
        else if (txt && txtOutline) { var oz = Math.round(pc(g.jh * 1.15 * 1.25)), oaw = g.jw * 1.08, ogap = Math.max(.9, g.jh * .45); x.textAlign = 'center'; x.textBaseline = 'top'; x.font = oz + 'px "DE24 Vereinsschrift", Impact, sans-serif'; x.lineJoin = 'round'; x.lineWidth = Math.max(2, oz * .06); x.strokeStyle = it.club_color || '#fff'; x.strokeText(String(txt).toUpperCase(), pc(jcx), pc(g.jy + g.jh + ogap + oaw * 147 / 1200 + ogap * .9)); }
        else if (txt) { x.fillStyle = it.club_color || '#1a9a3c'; x.textAlign = 'center'; x.textBaseline = 'top'; x.font = Math.round(pc(g.jh * 1.15)) + 'px "DE24 Vereinsschrift", Impact, sans-serif'; x.fillText(String(txt).toUpperCase(), pc(lcx), pc(lt + lh + 1.1)); }
      } else {
        x.drawImage(bk, 0, 0, S, S); var bw = 34, bt = g.jy + 2; if (bl) { x.drawImage(bl, pc(50 - bw / 2), pc(bt), pc(bw), pc(bw) * bl.height / bl.width); bt += bw * bl.height / bl.width + 3.3; }
        var bg = r[7], gw = 22; if (bg) x.drawImage(bg, pc(50 - gw / 2), pc(bt), pc(gw), pc(gw) * bg.height / bg.width);
      }
      try { return c.toDataURL('image/jpeg', .9); } catch (e) { return null; }
    });
  }
  // Basics: Platzierung kommt fertig aus dem Konfigurator (_dl24_layout: [{s:'f'|'b',u,x,y,w}] in % des Bildes)
  function mockBasic(it, side) {
    var lay = [], raw = String(it.properties._dl24_layout || ''); raw = raw.slice(Math.max(0, raw.indexOf('['))); // Shopify setzt teils „http://“ davor
    try { lay = JSON.parse(raw) || []; } catch (e) {}
    var mine = lay.filter(function (l) { return l.s === (side === 'back' ? 'b' : 'f'); });
    if (!mine.length) return Promise.resolve(null);
    return Promise.all([loadImg(side === 'back' ? it.img_back : it.img_front)].concat(mine.map(function (l) { return loadImg(l.u); }))).then(function (r) {
      var base = r[0]; if (!base) return null;
      var W = 960, H = Math.round(W * base.height / base.width), c = document.createElement('canvas'); c.width = W; c.height = H; var x = c.getContext('2d');
      x.fillStyle = '#fff'; x.fillRect(0, 0, W, H); x.drawImage(base, 0, 0, W, H);
      mine.forEach(function (l, i) { var im = r[i + 1]; if (!im) return; var w = l.w / 100 * W; x.drawImage(im, l.x / 100 * W, l.y / 100 * H, w, w * im.height / im.width); });
      try { return c.toDataURL('image/jpeg', .9); } catch (e) { return null; }
    });
  }
  function unesc(v) { return String(v == null ? '' : v).replace(/&quot;/g, '"').replace(/&#39;|&apos;/g, "'").replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&'); }
  function toObj(pr) { var o = {}; if (Array.isArray(pr)) pr.forEach(function (x) { if (Array.isArray(x) && x.length === 2) o[unesc(x[0])] = unesc(x[1]); }); else if (pr) Object.keys(pr).forEach(function (k) { o[k] = unesc(pr[k]); }); return o; }
  function quoteTransform(cart) {
    (cart.items || []).forEach(function (it) { it.properties = toObj(it.properties); });
    var items = cart.items || [], groups = {}, out = [], jobs = [];
    items.forEach(function (it) { var p = it.properties || {}; if (p._dl24_gruppe && p._dl24_ver == null) { (groups[p._dl24_gruppe] = groups[p._dl24_gruppe] || { ver: [], goods: [] }).ver.push(it); } });
    items.forEach(function (it) { var p = it.properties || {}; if (p._dl24_gruppe && p._dl24_ver != null && groups[p._dl24_gruppe]) groups[p._dl24_gruppe].goods.push(it); });
    items.forEach(function (it) {
      var p = it.properties || {}, g = p._dl24_gruppe && groups[p._dl24_gruppe];
      if (g && p._dl24_ver == null && g.goods.length) return; // Veredelung steckt in der Produktposition
      if (g && p._dl24_ver != null) {
        var pcs = g.goods.reduce(function (s, x) { return s + x.quantity; }, 0) || 1;
        var vt = g.ver.reduce(function (s, x) { return s + x.total; }, 0), vo = g.ver.reduce(function (s, x) { return s + x.original; }, 0);
        var n = Object.assign({}, it, { properties: {} });
        n.total = it.total + Math.round(vt / pcs * it.quantity); n.original = it.original + Math.round(vo / pcs * it.quantity);
        var parts = [], logos = {};
        Object.keys(p).forEach(function (k) { var v = p[k]; if (k[0] === '_') return; if (/^https?:/.test(String(v))) { parts.push(k); logos[k] = String(v); return; } if (/initialen|nummer/i.test(k)) { parts.push(k.split('/')[0].trim() + ' „' + v + '“'); return; } n.properties[k] = v; });
        n.properties['Veredelung'] = parts.join(' · ') + ' – inkl. ' + (vt / pcs / 100).toLocaleString('de-DE', { style: 'currency', currency: cart.currency || 'EUR' }) + ' je Teil';
        var key = p._dl24_gruppe;
        // 19.10.2026: Logo-Links stehen nicht im PDF, reisen aber in _de24_mockup_labels._logos mit – damit der Angebots-Konfigurator
        // (Mail-App) die Kundenlogos übernehmen kann. Fertige Bestell-Mockups vom Konfigurator (echte CDN-Bilder) werden bevorzugt.
        var real = /^https:\/\/cdn\.shopify\.com\//;
        if (real.test(String(p._preview || '')) || real.test(String(p._de24_mockup_2 || ''))) {
          var rl = {}; try { rl = JSON.parse(p._de24_mockup_labels || '{}') || {}; } catch (e) {}
          if (real.test(String(p._preview || ''))) { n.properties._preview = p._preview; rl._preview = rl._preview || 'Vorne'; }
          if (real.test(String(p._de24_mockup_2 || ''))) { n.properties._de24_mockup_2 = p._de24_mockup_2; rl._de24_mockup_2 = rl._de24_mockup_2 || 'Hinten'; }
          rl._logos = logos; n.properties._de24_mockup_labels = JSON.stringify(rl);
          out.push(n); return;
        }
        jobs.push(Promise.all([mock(it, 'front'), mock(it, 'back')]).then(function (m) {
          var labels = { _logos: logos };
          if (m[0]) { var u = 'https://druckelite24.de/cp-mockup/' + key + '-front.jpg'; MOCK[u] = m[0]; n.properties._preview = u; labels._preview = 'Vorne'; }
          if (m[1]) { var u2 = 'https://druckelite24.de/cp-mockup/' + key + '-back.jpg'; MOCK[u2] = m[1]; n.properties._de24_mockup_2 = u2; labels._de24_mockup_2 = 'Hinten'; }
          n.properties._de24_mockup_labels = JSON.stringify(labels);
        }));
        out.push(n); return;
      }
      if (p._dl24_upload) { if (typeof cart.total === 'number') cart.total -= it.total || 0; if (typeof cart.original_total === 'number') cart.original_total -= it.original || 0; return; } // nie im Angebot
      out.push(it);
    });
    cart.items = out;
    cart.quantity = out.reduce(function (s, x) { return s + (x.quantity || 0); }, 0);
    return Promise.all(jobs).then(function () { return cart; });
  }
  var QUOTE = /section_id=de24-quote-data/;
  function quoteFetch(p) {
    return p.then(function (r) {
      if (!r.ok) return r;
      return r.clone().text().then(function (html) {
        var m = html.match(/(<script[^>]*data-de24-quote-cart[^>]*>)([\s\S]*?)(<\/script>)/);
        if (!m) return r;
        var cart; try { cart = JSON.parse(m[2]); } catch (e) { return r; }
        return quoteTransform(cart).then(function (c) {
          var body = html.replace(m[0], m[1] + JSON.stringify(c).replace(/</g, String.fromCharCode(92) + 'u003c') + m[3]);
          return new Response(body, { status: 200, headers: { 'Content-Type': 'text/html' } });
        });
      }).catch(function () { return r; });
    });
  }

  // nach jeder Warenkorb-Änderung prüfen (fetch und XHR, z. B. LPO / Theme)
  var CART = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || (input instanceof URL ? input.href : '');
    var bd = arguments[1] && arguments[1].body;
    if (bd && typeof FormData !== 'undefined' && bd instanceof FormData && bd.has('properties[_dl24_upload]')) lastUpload = Date.now();
    if (QUOTE.test(String(url))) { var a = arguments; return check().then(function () { return quoteFetch(ofetch.apply(null, a)); }); }
    var p = ofetch.apply(null, arguments);
    if (CART.test(url)) p.then(function () { setTimeout(check, 300); }, function () {});
    return p;
  };
  var xo = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    if (CART.test(String(url))) this.addEventListener('loadend', function () { setTimeout(check, 300); });
    return xo.apply(this, arguments);
  };
  window.DL24Guard = { check: check };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', check); else check();
})();